import React from 'react';
import { Link } from 'react-router-dom';
import MetaTags from '../meta/MetaTags.jsx';
import './LandingSolutions.css';

const inviteFeatures = [
  { icon: '💌', title: 'Beautiful Digital Invitations', body: 'Design elegant, paperless invites with your theme, photos, and branding for weddings, birthdays, or corporate galas.' },
  { icon: '📨', title: 'Effortless RSVP Tracking', body: 'Collect replies, meal preferences, and plus-ones automatically. Guests get reminders so you don’t have to chase responses.' },
  { icon: '📝', title: 'Wedding Planning Tasks', body: 'Create to-do lists for venues, catering, rehearsals, and vendor follow-ups. Track deposits and payments alongside your invites.' },
  { icon: '📅', title: 'Shared Timelines', body: 'Give your bridal party and vendors a clear event timeline—ceremony, reception, speeches—so the day runs smoothly.' },
  { icon: '🏢', title: 'Fits Every Event', body: 'Use the same flow for baby showers, birthdays, and corporate events. Professional templates plus guest management in one place.' },
];

export default function InvitationWeddingTools() {
  return (
    <>
      <MetaTags profileKey="invitationWeddingServices" />
      <div className="landing-shell">
        <section className="section-hero">
          <span className="section-hero__eyebrow">Invitations &amp; Weddings</span>
          <h1 className="section-hero__title">Digital Invitation and Wedding Planning Services</h1>
          <p className="section-hero__subtitle">
            Design beautiful online invitations, manage RSVPs, and plan every wedding detail with integrated tasks, budgets, and timelines—all in one PartyDecider workspace.
          </p>
          <div className="cta-row" aria-label="Planner call to action">
            <Link to="/planner" className="btn primary">Start Planning Your Event</Link>
            <span className="cta-note">Paperless invites, real-time updates, zero printing costs.</span>
          </div>
        </section>

        <section className="block-panel">
          <h2 className="block-panel__title">Invitation services that stay connected</h2>
          <p className="block-panel__text">
            PartyDecider combines invitation design, RSVP management, and event logistics so you never switch tools. Update the event page once—everyone is notified instantly and sees the latest details.
          </p>
          <ul className="block-list" aria-label="Invitation and wedding features">
            {inviteFeatures.map((item) => (
              <li key={item.title} className="block-list__item">
                <span className="block-list__icon" aria-hidden="true">{item.icon}</span>
                <div>
                  <p className="block-list__title">{item.title}</p>
                  <p className="block-list__body">{item.body}</p>
                </div>
              </li>
            ))}
          </ul>
        </section>

        <section className="section-columns">
          <div className="block-card">
            <div className="block-card__eyebrow">Modern Workflow</div>
            <h3 className="block-card__title">Step-by-step wedding planning</h3>
            <p className="block-card__text">
              Move from save-the-date to ceremony with shared checklists, budget tracking, and real-time collaboration with your partner or co-planners.
            </p>
          </div>
          <div className="block-card">
            <div className="block-card__eyebrow">Go Paperless</div>
            <h3 className="block-card__title">Ditch the paper, embrace the evite</h3>
            <p className="block-card__text">
              Skip printing and postage. Send stylish e-invites, gather RSVPs online, and keep every guest up to date automatically.
            </p>
          </div>
          <div className="block-card">
            <div className="block-card__eyebrow">Cross-Event Ready</div>
            <h3 className="block-card__title">From weddings to work events</h3>
            <p className="block-card__text">
              Use the same toolkit for showers, anniversaries, and corporate celebrations. Templates and guest tools adapt to any event.
            </p>
          </div>
        </section>

        <section className="block-panel">
          <h2 className="block-panel__title">Make your next celebration simple</h2>
          <p className="block-panel__text">
            Create the invites of your dreams and manage the entire event from start to finish on one modern platform. Share access with co-hosts, vendors, and family so everyone stays aligned.
          </p>
          <div className="cta-row" aria-label="Planner call to action">
            <Link to="/planner" className="btn primary">Launch the Planner</Link>
            <Link to="/corporate-event-software" className="btn outline">See corporate planning</Link>
          </div>
        </section>
      </div>
    </>
  );
}
